import * as React from "react";
import * as moment from "moment";

import { StatusBar } from "./status_bar";
import { isWorkDay } from "../../date_helpers";
import { MOMENT_DATE_FORMAT } from "./calculator";


interface TimelineEventProps {
    title: string;
    img: string;
    idx: number;
    startDate?: moment.Moment;
    offset?: number;
    description?: string;
    disclaimer?: string;
}

function addWorkdays(date: moment.Moment, days: number): moment.Moment {
    date = moment(date);
    while (days > 0) {
        date = date.add(1, 'days');
        if (isWorkDay(date)) {
            days -= 1;
        }
    }
    return date;
}

export function TimelineEvent({ title, startDate, offset, img, idx, disclaimer, description }: TimelineEventProps): JSX.Element {
    let content = "";
    if ((typeof startDate !== "undefined") && (typeof offset !== "undefined")) {
        content = addWorkdays(startDate, offset).format(MOMENT_DATE_FORMAT);
    } else if (description) {
        content = description;
    }
    return (
        <div className="timeline__element">
            <h5><img className="timeline-icon" src={img} alt={title} />{title}</h5>
            <StatusBar maxFill={idx}/>
            <strong>{ content }</strong>
            { disclaimer && <p className="timeline__disclaimer">* {disclaimer}</p> }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/ts/components/calculator/timeline_event.tsx